import { useQuery } from '@tanstack/react-query';
import { isLocalOrBeta } from '../util/flags';

const POLL_INTERVAL_MS = 5 * 60 * 1000; // 5 minutes

/**
 * Periodically fetches /version.json and compares it to the build ID compiled
 * into this bundle. Returns true when the server has a newer build than the
 * one the user is currently running.
 */
export default function useNewVersionCheck(): boolean {
  const { data: hasNewVersion } = useQuery({
    queryKey: ['versionCheck'],
    queryFn: async () => {
      // Wait 10 seconds for app to finish loading
      await new Promise((resolve) => setTimeout(resolve, 10000));
      const res = await fetch(`/version.json?_=${Date.now()}`, { cache: 'no-store' });
      if (!res.ok) throw new Error('Failed to fetch version');
      const { buildId } = await res.json();
      return buildId as string;
    },
    select: (buildId) => buildId !== import.meta.env.VITE_BUILD_ID,
    refetchInterval: POLL_INTERVAL_MS,
    refetchOnWindowFocus: true,
    enabled: !isLocalOrBeta,
    staleTime: 0,
    retry: false,
  });

  return hasNewVersion ?? false;
}
